import { render, staticRenderFns } from "./LinkedCustomInvestorGoalBodyCard.vue?vue&type=template&id=62458fb2&scoped=true&"
import script from "./LinkedCustomInvestorGoalBodyCard.vue?vue&type=script&lang=ts&"
export * from "./LinkedCustomInvestorGoalBodyCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62458fb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
